export const STORAGE_KEY = '@RECENT_SESSIONS';

export type getSignature = () => Promise<TriageSession | boolean>;
export type setSignature = (sessionToken: string) => Promise<TriageSession | boolean>;
export type forgetSignature = () => Promise<boolean>;

export interface StorageInterface {
  getTriageSession: getSignature;
  setTriageSession: setSignature;
  forgetTriageSession: forgetSignature;
}

export interface TriageSession {
  date: Date;
  sessionToken: string;
}

export const newRecentSession = (sessionToken: string) => {
  return {
    date: new Date(),
    sessionToken
  } as TriageSession;
};
